module.exports = __webpack_public_path__ + "images/emoji/free.9830ebf2a5a3bec553da.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/free.png
// module id = VDtF
// module chunks = 14